
//
// Live Table Row
//
// Updates the controller when a dropdown value changes
//

module.exports = function LiveTableRowWidget ($host, config, $$) {


  // State

  var callbacks = { update: id };


  // DOM

  var $dropdowns = $$('select');
  var $buttons   = $$('button');


  // Functions

  function sendUpdate (type, ix, key, value) {
    callbacks.update(type, ix, key, value);
  }

  function blink (key, value, rowData) {

    // Special values that have extra effects
    if (key === 'completed' || key === 'cancelled') {
      var flashClass = 'is-' + key;
      $host.addClass(flashClass);

      delay(0.8, function () {
        if (rowData.cancelled) { setRowDataAttr('cancelled', 'true'); }
        if (rowData.completed) { setRowDataAttr('completed', 'true'); }
        defer(function () { $host.removeClass(flashClass) });
      });

    // Normal value updates
    } else {

      var flashClass = 'is-flashed';
      $host.addClass(flashClass);
      defer(function () { $host.removeClass(flashClass) });

    }
  }

  function copyValueToIcon (key, value) {
    var $valueHolder = $host.find('[data-live-key="' + key + '"] > [data-value]');
    if ($valueHolder.length) {
      $valueHolder.get(0).dataset.value = value;
    }
  }

  function highlightIx (ix) {
    if ($host.data('ix') == ix) $host.addClass('is-highlighted');
  }

  function createUpdateFromEvent (el, event) {
    var value = convertBool(el.value);
    sendUpdate(config.type, config.ix, el.parentNode.dataset.liveKey, value);
  }

  function setRowDataAttr (attr, value) {
    $host.attr('data-' + attr, value);
  }


  // Listeners

  $dropdowns.on('change', jqe(createUpdateFromEvent));
  $buttons.on('click',    jqe(createUpdateFromEvent));


  // Interface

  return {
    onUpdate:    function (λ) { callbacks.update = λ; },
    showSuccess: function (key, value, rowData) { copyValueToIcon(key, value); blink(key, value, rowData); },
    highlightIfMatching: highlightIx
  }

}

